/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_PAGE_FACADE = '/createOptInEntry';
const RESOURCE_ROOT_FACADE = '/sms';

const createOptInEntry = (wcEnv, jwtToken, optInEntry) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;
    const resourcePage = RESOURCE_PAGE_FACADE;

    return restClient.postFacade(env, resourcePage, jwtToken, optInEntry)
        .then((response) => response);
};

export default createOptInEntry;
